import * as React from 'react';
import { withTheme } from 'styled-components';

import Icon from 'components/common/Icon';

import {
  AccessibilityContainer,
  AccessibilityOptionContainer,
  AccessibilityOption,
  AccessibilityOptionText,
  FontSizeAdjustmentContainer,
  FontSizeAdjustmentButton,
  FontSizeAdjustmentOptionText
} from './Accessibility.styled';

type AccessibilityProps = {
  theme: any;
  visible: boolean;
  updateAccessibilitySettings: any;
  accessibilitySettings: any;
};

type AccessibilityState = {};

type AccessibilityOptionDetails = {
  'data-test': string;
  key: string;
  label: string;
  visible?: boolean;
  fullWidth?: boolean;
  showFontSizeAdjustment?: boolean;
  icon: {
    name: string;
    size: number;
  };
};

const accessibilityOptionsList: Array<AccessibilityOptionDetails> = [
  {
    'data-test': 'contrast-theme-button',
    visible: true,
    fullWidth: true,
    key: 'isContrastTheme',
    label: 'Contrast Theme',
    icon: {
      name: 'contrast',
      size: 20
    }
  },
  {
    'data-test': 'readable-font-button',
    key: 'isReadableFont',
    label: 'Readable Font',
    icon: {
      name: 'readable-font',
      size: 20
    }
  },
  {
    'data-test': 'font-size-adjustment-button',
    key: 'fontSize',
    label: 'Font Size Adjustment',
    fullWidth: true,
    showFontSizeAdjustment: true,
    icon: {
      name: 'font-size',
      size: 20
    }
  },
  {
    'data-test': 'dyslexia-font-button',
    key: 'isDyslexiaFont',
    label: 'Dyslexia Font',
    icon: {
      name: 'dyslexia',
      size: 20
    }
  },
  {
    'data-test': 'seizure-safe-button',
    key: 'isSeizureSafe',
    label: 'Seizure Safe',
    icon: {
      name: 'seizure-safe',
      size: 20
    }
  }
];

export class Accessibility extends React.Component<AccessibilityProps, AccessibilityState> {
  onToggleSetting = (key: string) => {
    this.props.updateAccessibilitySettings({
      ...this.props.accessibilitySettings,
      [key]: !this.props.accessibilitySettings[key]
    });
  };

  getAccessibilityOption = (option: AccessibilityOptionDetails, templateTheme: any) => (
    <AccessibilityOptionContainer
      theme={templateTheme}
      data-test={option['data-test']}
      fullWidth={option.fullWidth || false}
      key={option.key}
      visible={option.visible || false}
      enabled={this.props.accessibilitySettings[option.key]}
      onClick={() => this.onToggleSetting(option.key)}
    >
      <AccessibilityOption>
        <Icon name={option.icon.name} theme={templateTheme} size={option.icon.size} />
        {option.showFontSizeAdjustment ? (
          <>
            <FontSizeAdjustmentOptionText theme={templateTheme}>
              {option.label}
            </FontSizeAdjustmentOptionText>
            <FontSizeAdjustmentContainer theme={templateTheme}>
              <FontSizeAdjustmentButton theme={templateTheme}>-</FontSizeAdjustmentButton>
              Default
              <FontSizeAdjustmentButton theme={templateTheme}>+</FontSizeAdjustmentButton>
            </FontSizeAdjustmentContainer>
          </>
        ) : (
          <AccessibilityOptionText theme={templateTheme}>{option.label}</AccessibilityOptionText>
        )}
      </AccessibilityOption>
    </AccessibilityOptionContainer>
  );

  render() {
    const { visible, theme } = this.props;
    return (
      <AccessibilityContainer visible={visible}>
        {accessibilityOptionsList.map((option: AccessibilityOptionDetails) =>
          this.getAccessibilityOption(option, theme)
        )}
      </AccessibilityContainer>
    );
  }
}
export default withTheme(Accessibility);
